<template>
    <div>
        <ul class="con-s">
            <li>
                <label for="">Ramadan Mode</label>
                <vs-switch v-model="ramadan" vs-icon-off="moon" vs-icon-on="moon"  @change="updateSettings"/>
            </li>
        </ul>
        <br>
        <vs-button color="primary" icon="add" @click="addWindow=!addWindow">Add Widget</vs-button>
        <br>
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">

            <vs-card>
                <div slot="header">
                    <h3>
                        Test Widget
                    </h3>
                </div>
                <div>

                </div>
                <div slot="footer">
                    <vs-row vs-justify="flex-end">
                        <vs-button type="gradient" color="danger" icon="favorite"></vs-button>
                        <vs-button color="primary" icon="turned_in_not"></vs-button>
                        <vs-button color="rgb(230,230,230)" color-text="rgb(50,50,50)" icon="settings"></vs-button>
                    </vs-row>
                </div>
            </vs-card>
        </vs-col>

        <vs-popup classContent="popup-example" title="Add Explore Widget" :active.sync="addWindow">
            <vs-input class="inputx" placeholder="Arabic Name" v-model="widget.ar_name" />
            <br>
            <vs-input class="inputx" placeholder="English Name" v-model="widget.en_name" />
            <vs-divider />
            <p> The design may differ from one application to another</p>
            <vs-select label="Widget" v-model="widget.options">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in widgetList" />
            </vs-select>
            <vs-divider />
            <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                   <label for="">only special</label>
                <vs-switch v-model="ramadan" vs-icon-off="moon" vs-icon-on="moon" />
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                   <label for="">Kids</label>
                <vs-switch v-model="ramadan" vs-icon-off="moon" vs-icon-on="moon" />
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                    <vs-select label="Kind" v-model="widget.options">
                      <vs-select-item  value="0" text="Any"  />
                      <vs-select-item  value="1" text="Movies"  />
                      <vs-select-item  value="2" text="Series"  />
                  </vs-select>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                    <vs-select label="Sort By" v-model="widget.options">
                      <vs-select-item  value="0" text="Any"  />
                      <vs-select-item  value="1" text="Movies"  />
                      <vs-select-item  value="2" text="Series"  />
                  </vs-select>
                </vs-col>
            </vs-row>


        </vs-popup>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                ramadan: false,
                widgets: [],
                addWindow: false,
                widget: {
                    section: 0,
                    ar_name: '',
                    en_name: '',
                    widget: '',
                    options: [],
                },
                widgetList: [{
                        text: 'IT',
                        value: 0
                    },
                    {
                        text: 'Blade Runner',
                        value: 2
                    },
                    {
                        text: 'Thor Ragnarok',
                        value: 3
                    },
                ]
            }
        },
        created() {
            this.fetchSettings();
        },
        methods: {
            fetchSettings(){
                axios.get(`${this.$apiUrl}/v2/check`).then(res=>{
                 this.ramadan=res.data.ramadan==1?true:false
            })
            },
            updateSettings(){
                const items=new FormData();
                items.append('ramadan_mode',this.ramadan?1:0)
             this.axios.post(`${this.$apiUrl}/v2/settings`,items).then(res => {
                    this.items = this.def_group;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Settings Update',
                        })
                    }
                  this.fetchComments();
                })
            }
        },
    }
</script>